import React, { Component } from 'react';
import { connect } from 'react-redux';
import AlertMessage from '../AlertMessage/AlertMessage';
import RangeInput from '../../shared/RangeInput';
import MultiSelectComponent from '../../shared/MultiSelectComponent';
import { operativeProcedureTypes } from '../../helpers/constants';
import { getUserRoleType } from '../../services/aws/aws-services';
import { salesRepMessages } from '../../helpers/messages';

class CaseFilterComponent extends Component {
	constructor(props) {
		super(props);
		this.filterRef = React.createRef();
    this.onEnterPress = this.onEnterPress.bind(this);
	}

	/**
	 * @description Function to reset filter form
	 * @memberof CaseFilterComponent
	 */
	resetForm = () => {
		this.filterRef.reset();
		this.props.resetCaseFilter();
	}

  /**
     *  @description Function to handle search submit by hitting enter key
     *  @param e Keypress event
     *  @memberof CaseFilterComponent
     */
  onEnterPress = (e) => {
    if (e.which === 13) {
        e.preventDefault();
        this.props.filterCaseList();
    }
};

	/**
	 * @description Function to get conditional anatomical options based on procedure type
	 * @memberof CaseFilterComponent
	 */
	switchAnatomicalFilters = () => {
		const { operativeProcedure, operativeApproach, defaults, handleRangeChange, preopDeformity, pelvicTilt, onInputChange } = this.props;
		switch (operativeProcedure) {
			case operativeProcedureTypes.TKA.raw:
				return <div className="col-md-3 mb-4">
				    <label className='custom-label' htmlFor="preop-deformity">Deformity</label>					
					<RangeInput
						id="preop-deformity"
						data-testid="preop-deformity"
						step="1"
						min={defaults.preopDeformity.min}
						max={defaults.preopDeformity.max}
						openRange={true}
						showExtremeLabels={true}
						minExtremeLabel="Valgus"
						maxExtremeLabel="Varus"
						openMinLabel="< -7"
						openMaxLabel="> 7"
						minVal={preopDeformity.min}
						maxVal={preopDeformity.max}
						handleChange={(values) => handleRangeChange(values, 'preopDeformity')}
					/>
				</div>
			case operativeProcedureTypes.HIP.raw:
				return <div className="col-md-3 mb-4">
					<label className='custom-label' htmlFor="pelvic-tilt">Pelvic Tilt</label>										
					<RangeInput
						id="pelvic-tilt"
						data-testid="pelvic-tilt"
						step="1"
						min={defaults.pelvicTilt.min}
						max={defaults.pelvicTilt.max}
						openRange={true}
						showExtremeLabels={true}
						minExtremeLabel="< -15"
						maxExtremeLabel="> 15"
						openMinLabel="< -15"
						openMaxLabel="> 15"
						minVal={pelvicTilt.min}
						maxVal={pelvicTilt.max}
						handleChange={(values) => handleRangeChange(values, 'pelvicTilt')}
					/>
				</div>
			case operativeProcedureTypes.TSA.raw:
				return <div className="col-md-3 mb-4">
					<label className='custom-label' htmlFor="operativeApproach">Procedure Type</label>										
					<select data-testid="operativeApproach" id="operativeApproach" className="form-select" value={operativeApproach} onChange={(e) => onInputChange(e, 'operativeApproach')}>
						<option value="" >All</option>
						<option value="reverse">Reverse</option>
						<option value="anatomic">Anatomic</option>
					</select>
				</div>
			default:
				return null;
		}
	}

	render() {
		const { showFilter, onInputChange, showFilterBlock, errorMessage, todayDate, surgeryFromDate, surgeryToDate, operativeProcedure,
			disableFilter, disableReset, surgeons, patientSex, patinetSexList, handlePatientSexChange, defaults, initialState, handleRangeChange, implants,
			side, implantValue, patientAge, selectedSurgeon, handleSurgeonChange, userRoles, gapsCollectedData, workFlowType, searchString, activeTab = 'caseList' } = this.props;
   // Search input placeholder need to be changed based on userRole
    const userRole = getUserRoleType();
    let searchPlaceHolder = salesRepMessages.caseFilterSurgeonSearchPlaceholder

    if (userRole.includes('rar')){
      searchPlaceHolder = salesRepMessages.caseFilterRarSearchPlaceholder;
		}else if(userRole.includes('careteam')){
      searchPlaceHolder = salesRepMessages.caseFilterSurgeonSearchPlaceholder
    		}
		return (
			<div data-testid="caseFilterComponent">
				<div className="case-list-top-btn">
					<button className="btn btn-primary" onClick={showFilter}>{showFilterBlock ? 'Hide' : 'Show'} Filter</button>
				</div>
				{showFilterBlock ? <div className="case-list-filter">
					{errorMessage ? <AlertMessage errorMessage={errorMessage} /> : null}
					<form className='p-4' id="casefilter" ref={(el) => (this.filterRef = el)}>
              <div className="row">
                <div className="col-md-3 mb-4">
                  <label className='custom-label' htmlFor="operativeProcedure">Procedure</label>
                  <select
                    data-testid="operativeProcedure"
                    id="operativeProcedure"
                    className="form-select"
                    value={operativeProcedure}
                    onChange={(e) => onInputChange(e, "operativeProcedure")}
                  >
                    <option value="">All Procedures</option>
                    <option value={operativeProcedureTypes.HIP.raw}>
                      {operativeProcedureTypes.HIP.longText}
                    </option>
                    <option value={operativeProcedureTypes.TKA.raw}>
                      {operativeProcedureTypes.TKA.longText}
                    </option>
                    <option value={operativeProcedureTypes.TSA.raw}>
                      {operativeProcedureTypes.TSA.longText}
                    </option>
                  </select>
                </div>

                {activeTab === 'caseList' && (
                   <div className='col-md-3 mb-4'>
                   <div className='justify-content-between gap-2'>
                   <label className='custom-label' htmlFor="case-filter-search">Search</label>
                                 <input
                                     type='text'
                                     id='case-filter-search'
                                     data-testid="case-filter-search"
                                     className='form-control pre-op-search-input'
                                     placeholder={searchPlaceHolder}
                                     value={searchString}
                                     onChange={(e) => onInputChange(e, 'searchString')}
                                     onKeyDown={this.onEnterPress}
                                 />
                    </div>
               </div>

                )}
 
                <div className="col-md-3 mb-4">
                  <label className='custom-label' htmlFor="surgeryFromDate">Surgery From Date</label>
                  <input
                    className="form-control"
                    type="date"
                    data-testid="surgeryFromDate"
                    id="surgeryFromDate"
                    value={surgeryFromDate || ""}
                    max={todayDate}
                    onChange={(e) => onInputChange(e, "surgeryFromDate")}
                  />
                </div>
 
                <div className="col-md-3 mb-4">
                  <label className='custom-label' htmlFor="surgeryToDate">Surgery To Date</label>
                  <input
                    className="form-control"
                    type="date"
                    data-testid="surgeryToDate"
                    id="surgeryToDate"
                    max={todayDate}
                    value={surgeryToDate || ""}
                    onChange={(e) => onInputChange(e, "surgeryToDate")}
                  />
                </div>

                <div className="col-md-3 mb-4">
                  <label className='custom-label' htmlFor="patient-age">Patient Age</label>
                  <RangeInput
                    id="patient-age"
                    data-testid="patient-age"
                    step="1"
                    showExtremeLabels={true}
                    openRange={true}
                    minExtremeLabel={defaults.patientAge.min}
                    maxExtremeLabel={defaults.patientAge.maxLabel}
                    min={defaults.patientAge.min}
                    max={defaults.patientAge.max}
                    minVal={patientAge.min}
                    maxVal={patientAge.max}
                    openMinLabel="0"
                    openMaxLabel="> 100"
                    reset={initialState}
                    handleChange={(values) =>
                      handleRangeChange(values, "patientAge")
                    }
                  />
                </div>
 
                <div className="col-md-3 mb-4">
                  <label className='custom-label' htmlFor="patient-sex">Patient Sex</label>
                  <MultiSelectComponent
                    id="patient-sex"
                    options={patinetSexList}
                    displayValue="label"
                    selectedValues={patientSex}
                    handleSelectChange={handlePatientSexChange}
                    placeholder={patientSex ? "Select" : "All"}
                  />
                </div>

				        <div className="col-md-3 mb-4">
                  <label className='custom-label' htmlFor="side">Operative Side</label>
                  <select
                    data-testid="side"
                    id="side"
                    className="form-select"
                    value={side}
                    onChange={(e) => onInputChange(e, "side")}
                  >
                    <option value="">All Sides</option>
                    <option value="left">Left</option>
                    <option value="right">Right</option>
                  </select>
                </div>
				{userRoles ? (
                  <div className="col-md-3 mb-4">
                    <label className='custom-label' htmlFor="surgeon-select">Surgeon</label>
                    <MultiSelectComponent
                      id="surgeon-select"
                      options={surgeons && surgeons.length ? surgeons : []}
                      displayValue="name"
                      selectedValues={selectedSurgeon}
                      handleSelectChange={handleSurgeonChange}
                      placeholder={selectedSurgeon ? "Select" : "All Surgeons"}
                    />
                  </div>
                ) : (
                  ""
                )}
				{this.switchAnatomicalFilters()}
				{[
                operativeProcedureTypes.TKA.raw,
                operativeProcedureTypes.TSA.raw,
              ].indexOf(operativeProcedure) > -1 ? (
                  <div className="col-md-3 mb-4">
                    <label className='custom-label' htmlFor="implant-select">Implant Type</label>
                    <select
                      data-testid="implant-select"
                      id="implant-select"
                      className="form-select"
                      name="implant"
                      value={implantValue}
                      onChange={(e) => onInputChange(e, "implant")}
                    >
                      <option value="">All Implants</option>
                      {implants && implants.length
                        ? implants.map((implant, index) => {
                            return (
                            <option key={index}
                            value={implant.name}>
                              {implant.name}
                              </option>
                              )
                          })
                        : ""}
                    </select>
                  </div>
              ) : (
                ""
              )}

			  {operativeProcedure === operativeProcedureTypes.TKA.raw ? (
				<>
                  <div className="col-md-3 mb-4">
                    <label className='custom-label' htmlFor="gaps-select">Gaps Collected</label>
                    <select
                      data-testid="gaps-select"
                      id="gaps-select"
                      className="form-select"
                      value={gapsCollectedData}
                      onChange={(e) => onInputChange(e, "gapsCollectedData")}
                    >
                      <option value="">All</option>
                      <option value="Manual">Manual</option>
                      <option value="Tensioner">Tensioner</option>
                    </select>
                  </div>
 
                  <div className="col-md-3 mb-4">
                    <label className='custom-label' htmlFor="tka-work-flow-select">Workflow</label>
                    <select
                      data-testid="tka-work-flow-select"
                      id="tka-work-flow-select"
                      className="form-select"
                      value={workFlowType}
                      onChange={(e) => onInputChange(e, "workFlowType")}
                    >
                      <option value="">All</option>
                      <option value="Image Based">Image Based</option>
                      <option value="Image Free">Image Free</option>
                    </select>
                  </div>
				  </>
              ) : (
                ""
              )}
                 
              </div>
 
              <div className="row">
                <div className="col-4 filter-btns">
                  <button
                    className="btn btn-primary filter-btn-width"
                    type="button"
                    disabled={disableFilter}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.filterCaseList();
                    }}
                    id="caseFilter"
                    data-testid="caseFilter"
                  >
                    Filter
                  </button>
                  <button
                    className="btn btn-primary filter-btn-width"
                    type="button"
                    disabled={disableReset}
                    onClick={this.resetForm}
                    id="caseReset"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </form>
				</div> : null}
			</div>
		);
	}
}
const mapStateToProps = (state) => (
	{
		state
	}
)
const mapDispatchToProps = (dispatch) => ({

})
export default connect(mapStateToProps, mapDispatchToProps)(CaseFilterComponent);
